import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './components/home/home.component';
import {HeaderComponent} from './components/general/header/header.component';
import {FooterComponent} from './components/general/footer/footer.component';
import {CookieComponent} from './components/general/cookie/cookie.component';
import {CookieService} from 'ngx-cookie-service';
import {AboutMeComponent} from './components/about-me/about-me.component';
import {PhotographyComponent} from './components/photography/photography.component';
import {ContactComponent} from './components/contact/contact.component';
import {SitemapComponent} from './components/sitemap/sitemap.component';
import {ImpressumComponent} from './components/impressum/impressum.component';
import {WorldpageComponent} from './components/worldpage/worldpage.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {StepsComponent} from './components/steps/steps.component';
import {WerteComponent} from './components/werte/werte.component';
import {NewssliderComponent} from './components/newsslider/newsslider.component';
import {NewsComponent} from './components/news/news.component';
import {ConceptionComponent} from './components/work/conception/conception.component';
import {UxdesignComponent} from './components/work/uxdesign/uxdesign.component';
import {ProgrammingComponent} from './components/work/programming/programming.component';
import {QualityComponent} from './components/work/quality/quality.component';
import {ReferenceComponent} from './components/reference/reference.component';
import {NewscontentComponent} from './components/news/newscontent/newscontent.component';
import {HttpClientModule} from '@angular/common/http';
import {LandscapeComponent} from './components/photocategory/landscape/landscape.component';
import {SailingComponent} from './components/photocategory/sailing/sailing.component';

import {LocalComponent} from './components/photocategory/local/local.component';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {AngularMaterialModule} from './angular-material.module';

import { PhotoComponent } from './components/photo/photo.component';
import {dialogDataComponent} from './components/modules/dialogData/dialogData.component';
import { WeatherComponent } from './components/weather/weather.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ApixuService} from './service/apixu.service';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        FooterComponent,
        CookieComponent,
        AboutMeComponent,
        PhotographyComponent,
        ContactComponent,
        SitemapComponent,
        ImpressumComponent,
        WorldpageComponent,
        PageNotFoundComponent,
        StepsComponent,
        WerteComponent,
        NewssliderComponent,
        NewsComponent,
        ConceptionComponent,
        UxdesignComponent,
        ProgrammingComponent,
        QualityComponent,
        ReferenceComponent,
        NewscontentComponent,
        LandscapeComponent,
        SailingComponent,
        LocalComponent,
        dialogDataComponent,
        PhotoComponent,
        WeatherComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        NoopAnimationsModule,
        BrowserAnimationsModule,
        AngularMaterialModule,
        ReactiveFormsModule
    ],
    providers: [CookieService, ApixuService],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    entryComponents: [dialogDataComponent]
})
export class AppModule {
}
